import UIkit from 'uikit';

const XDSlider = {
  openModalToIndex: (modalTarget, modalSliderTarget, index) => {  
    UIkit.slider('#' + modalSliderTarget).show(index);
    setTimeout(() => { UIkit.modal('#' + modalTarget).show(); }, 300, modalTarget);
  },
  
  
  addModalTriggers: () => {
    if (window.innerWidth >= 640) {
      const target = '.js-xd-components__slider .js-xd-components__slider-lightbox-open li'
      document.querySelectorAll(target).forEach((el) => {
        const currentIndex = [...el.parentElement.children].indexOf(el);
        const parentId = el.parentElement.id.replace('-carousel','');
        const modalTarget = parentId + '-lightbox';
        const modalSliderTarget = parentId + '-lightbox-slider';
        
        el.addEventListener('click', (e) => {
          e.preventDefault
          XDSlider.openModalToIndex(modalTarget, modalSliderTarget, currentIndex);
        });   
      });
    }
  },
  
  init: () => {
    XDSlider.addModalTriggers();
    window.onresize = XDSlider.addModalTriggers;
  }
};

export default XDSlider;
